module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"systems":"Systemer","games":"Spill"},"en":{"systems":"Systems","games":"Games"}}')
  delete Component.options._Ctor
}
